import { SCHOOL_TYPES } from "@routebot/constants";

// Bu fonksiyon her sayfaya özel blocker'ları verir
export const noRealSchoolBlocker = (schools) => {
  if (schools?.filter((s) => s.type === SCHOOL_TYPES.SCHOOL).length === 0) {
    return {
      condition: true,
      message: "noSchoolError",
      cta: "addSchool",
      redirectTo: "/schools?tab=schools#newitem",
    };
  }
  return null;
};

export const noPersonelSchoolBlocker = (schools) => {
  if (schools?.filter((s) => s.type === SCHOOL_TYPES.PERSONEL).length === 0) {
    return {
      condition: true,
      message: "noPersonelSchoolError",
      cta: "addPersonelSchool",
      redirectTo: "/schools?tab=companies#newitem",
    };
  }
  return null;
};

export const noShiftsBlocker = (shifts) => {
  if (!shifts?.length) {
    return {
      condition: true,
      message: "noShiftsShiftManagement",
      cta: "goToShifts",
      redirectTo: "/shifts#newitem",
    };
  }
  return null;
};
